// extracted by mini-css-extract-plugin
export default {"component":"StatusButtonStyles_component__ABIiY","text":"StatusButtonStyles_text__h-NX7","componentProcessing":"StatusButtonStyles_componentProcessing__1wSRC"};